<h1>CONDITIONS GENERALES DE VENTE EN LIGNE DE PRESTATION DE RESTAURATION</h1>
<p>
  Les présentes Conditions Générales de Vente décrivent le service de commande en ligne d'une partie de la gamme de produits disponibles dans les restaurants,
  sur les points de livraison ou, le cas échéant, sur le lieu de travail, dont le prestataire de services de restauration est le Vendeur et accessible via le
  site ou l'application iOS/Android TIMECHEF (ci-après le « Site Timechef» ou le « Site »). Ces produits seront retirés sur le lieu ou point de livraison selon
  le mode de retrait indiqué lors de la validation de la commande.
</p>

<p>
  Dans le cas où les espaces de restauration disposent d'un point de collecte et/ou de retrait en libre-service, les Produits pourront être mis à disposition
  des Clients sur ces points de collecte et/ou de retrait dédiés. Les Produits pourront également être livrés directement sur le lieu de travail des Clients
  sous réserve d'un accord préalable et écrit avec la société employeur du Client.
</p>
<p>
  Cette mise à disposition peut s'effectuer via un meuble réfrigérant ou via un casier connecté maintenant la température recommandée, ou par la remise par le
  personnel Elior d'un sac, d'un panier repas, d'un plateau repas ou d'un repas servi à table.
</p>
<p>
  Les termes le « Vendeur » désigne l'entité du Groupe ELIOR prestataire de services de restauration (ANSAMBLE SAS, ELIOR RESTAURATION France SAS, L'Alsacienne
  de Restauration SAS ou toute autre entité du Groupe ELIOR) du restaurant dont le Client est convive, et entité auprès de laquelle la commande sera
  enregistrée.
</p>
<p>
  Les présentes Conditions Générales de Vente (ci-après les « CGV ») s'appliquent à toute réservation ou achat (ci-après « Commande ») d'un ou plusieurs
  produits (ci-après le ou les « Produit(s) ») effectué(e) par le convive (ci-après le « Client ») sur le Site auprès de l'un des restaurants.
</p>
<h2>1 - Acceptation des CGV</h2>

<p>
  Le Client déclare avoir pris connaissance et accepté les présentes CGV avant la passation de sa Commande. Pour matérialiser l'accord du Client, celui-ci doit
  cocher la case "J'accepte les Conditions Générales d'Utilisation et de Vente" prévue à cet effet sur le Site avant de passer la Commande et/ou au paiement,
  selon le cas. Le Client reconnaît que le "double clic" associé à la case "J'accepte les Conditions Générales d'Utilisation et de Vente" et à la validation
  définitive de la Commande vaut consentement à contracter et constitue une acceptation irrévocable et sans réserve des CGV.
</p>

<p>
  La Commande sur le Site est réservée aux Clients âgés d'au moins 18 ans à la date de passation de la Commande pour les restaurants dont la carte présente des
  boissons alcoolisées. Le Client déclare être majeur et pleinement capable de contracter.
</p>

<p>Les présentes CGV prévaudront sur toutes autres conditions générales ou particulières non expressément agréées par le Vendeur.</p>

<p>
  Le Vendeur se réserve le droit de modifier les CGV à tout moment. Dans tous les cas, les CGV applicables seront celles figurant sur le Site à la date de la
  Commande par le Client.
</p>

<h2>2 - Les Produits</h2>

<p>
  Les produits proposés par le Restaurant sont ceux qui figurent dans le catalogue publié sur le Site le jour de la Commande ou de la livraison prévue, dans la
  limite toutefois des stocks disponibles. Les Produits doivent être consommés au plus tard dans les 24h à compter de leur retrait ou de leur mise à disposition
  et doivent être conservés entre 0 et 3°C. Ils ne doivent pas être congelés.
</p>

<p>
  Les produits présentés à la vente sont susceptibles d'être modifiés ou supprimés par le Vendeur sans aucun préavis. Les photographies et illustrations
  présentées en ligne ne sont pas contractuelles.
</p>

<p>
  Le Client ayant passé Commande déclare avoir pris connaissance des détails, de la préparation et des informations sur les Produits indiqués dans chaque fiche
  produit du Site.
</p>

<p>
  Il appartient au Client de se renseigner sur ses allergies ou intolérances à certains produits et à rechercher les traces de ces produits via les informations
  allergènes indiquées sur la fiche produit ou auprès des services du Vendeur. Le Vendeur ne pourra être tenu responsable des conséquences de la non prise en
  compte de ces informations par le Client lors de son achat.
</p>

<p>
  Les informations sur les allergènes concernent exclusivement les 14 allergènes majeurs introduits volontairement dans les préparations. Les produits vendus
  sont préparés dans des ateliers ou cuisines où toute ou une partie de ces substances allergènes sont présentes. Aussi malgré toutes les précautions prises, ne
  peut être exclue la contamination croisée accidentelle entre préparations.
</p>

<p>
  En cas d'indisponibilité d'un ou de plusieurs produits après passation de la Commande, ou -pour Scorp- après passation de la Commande - le Client sera averti
  par e-mail, par téléphone ou via l'application, de manière explicite.
</p>

<p>Dans le cas où la commande est encore modifiable, le convive peut changer d'articles dans sa commande ou annuler sa commande.</p>

<p>
  Si le délai de modification de commande a expiré ou pour les commandes passées le jour-même, sur présentation au gérant du restaurant dans lequel le Client
  est convive du bon de commande validé et, selon les cas, du justificatif de paiement reçu par mail, le gérant du restaurant procédera au recalcul du montant
  de la Commande. La commande fera l'objet d'une annulation et en cas de débit, le Client sera recrédité du montant des Produits manquants, sur son badge ou
  portefeuille électronique, s'il en est détenteur, dans un délai de 24h ou directement à la caisse du restaurant principal pour les non-détenteurs de badge. En
  cas d'indisponibilité des produits avant ou après Commande, le Vendeur ne pourra être tenu responsable d'aucun préjudice subi par le Client, ni tenu à aucun
  dommage-intérêt.
</p>

<h3>3 - Création d'un compte</h3>

<p>
  Pour commander, le Client doit être détenteur d'un compte Timechef ; dans les cas des restaurants de type SCORP, il doit également être autorisé à la commande
  du fait de son entreprise et de la création de son profil par le Responsable du Site.
</p>

<p>Dans le cadre d'une inscription, le Client choisit un identifiant qui correspond à une adresse électronique en état de fonctionnement et un mot de passe.</p>

<p>
  Dans le cas des restaurants de type SCORP, le Client est informé qu'un rapprochement est fait entre les informations reçues de son employeur (et qui
  transitent par la caisse du restaurant) et les données de son inscription afin de l'identifier comme un Client éligible SCORP.
</p>

<p>
  Il appartient au Client de garder ses informations strictement confidentielles et de ne pas les communiquer à des tiers, afin d'éviter autant que possible
  tout risque d'intrusion dans son compte Client et la passation de Commandes en son nom et à son insu par des personnes non autorisées. Le Vendeur ne saurait
  être tenu responsable de toute utilisation du compte du Client par un tiers qui aurait eu accès à son identifiant et à son mot de passe de quelque manière que
  ce soit.
</p>

<p>
  Lors de son inscription, certaines données obligatoires seront demandées au Client et notamment son nom, prénom, numéro de badge, solde, adresse email ou
  matricule selon l'option de sécurité activée ainsi que le nom du site de restauration. Conformément à la politique de données personnelles en article 13, ces
  données permettent au Client de bénéficier du Service de Commande décrit aux présentes. Il pourra indiquer ultérieurement son numéro de téléphone de façon non
  obligatoire.
</p>

<h3>4 - Processus de passation des Commandes</h3>

<ul>
  <li>- se rendre sur le Site</li>
  <li>- créer un compte ou s'y connecter avec son identifiant et son mot de passe</li>
  <li>- sélectionner l'espace de commande</li>
  <li>- sélectionner les Produits,</li>
  <li>- accepter les CGV,</li>
  <li>- valider sa Commande après avoir vérifié le récapitulatif de sa Commande,</li>
  <li>- dans le cas où le paiement est effectué en ligne, procéder à la sélection du moyen de paiement et payer sa Commande</li>

  <li>
    -dans le cas où le paiement est différé, la validation de la Commande vaut pour autorisation de retrait du montant de la Commande qui sera effectif le jour
    de la mise à disposition de la Commande puis
  </li>

  <li>
    - se rendre sur le lieu de retrait validé lors de la commande muni de son bon de commande envoyé par le Vendeur par sms, push et/ou email ou via
    l'application en fonction du mode disponible choisi par le Client pour récupérer sa Commande et procéder au règlement lorsque le paiement n'a pas été
    effectué en ligne selon les modalités de paiement prévues à cet effet.
  </li>
</ul>

<p>
  Pour le cas des restaurants de type SCORP, la Commande est livrée, sur le créneau choisi (matin, midi ou soir), sur le lieu de travail convenu avec
  l'employeur du Client.
</p>

<p>
  Pour des raisons de sécurité, les dépenses journalières et les dépenses par Commande en ligne du Client ne peuvent pas excéder 200€ pour un paiement en carte
  bleue lorsque ce mode de paiement est disponible. Au-delà de ce plafond, le Client ne pourra plus Commander avant le lendemain ou devra retirer des éléments
  de son panier pour ne pas dépasser ces limites de dépenses.
</p>

<p>Dans le cas des restaurants de type SCORP et en cas de pré-paiement, le Client doit disposer d'un solde de badge suffisant pour couvrir les Commandes.</p>

<p>
  Le Vendeur se réserve le droit de suspendre ou d'annuler toute exécution d'une Commande, quelle que soit sa nature et niveau d'exécution, en cas de défaut de
  paiement ou paiement partiel de toute somme qui serait due par le Client, en cas d'incident de paiement, ou en cas de fraude ou tentative de fraude relative à
  l'utilisation du Site, y compris à l'occasion de Commande.
</p>

<h2>5 - Preuve de la Commande</h2>

<p>
  Le bon de commande (ou bon plateau) délivré à la validation finale de la Commande vaudra preuve de l'intégralité de ladite Commande et exigibilité des sommes
  engagées par la Commande.
</p>

<p>
  Dans le cas des restaurants de type SCORP, pour les convives en post-paiement, un récapitulatif non détaillé des Commandes est adressé à l'employeur du
  Client. Cet envoi permet le règlement, par l'employeur, des sommes dues par le Client.
</p>

<p>
  Le Vendeur procédera à l'archivage des bons de commandes validés et payés sur un support fiable et durable, constituant une copie fidèle conformément aux
  dispositions en vigueur.
</p>

<p>
  Les registres informatisés du Vendeur seront considérés par le Vendeur et le Client comme preuve des communications, des commandes, des paiements et des
  transactions intervenues entre les parties.
</p>

<h2>6 - Annulation et modification d'une Commande</h2>

<p>
  Le droit de rétractation applicable en matière de vente à distance (article L121-21-8 du code de la consommation) ne peut être exercé dans le cas de la
  fourniture de biens qui du fait de leur nature sont susceptibles de se détériorer ou de se périmer rapidement.
</p>

<p>
  En application de ce texte, il est expressément indiqué que toute Commande sur le Site est ferme et définitive et que l'exercice du droit de rétractation est
  exclu.
</p>

<p>
  Les Commandes de la veille pour le lendemain, le jour même, ou qui sont arrivées à la date butoir de modification et qui ont donc été définitivement validées
  et payées ne sont pas annulables. Aucune marchandise ne peut être reprise ou échangée.
</p>

<p>
  Les Commandes en différé en mode prélèvement à livraison sont annulables jusqu'à la date limite de Commande. Aucun prélèvement ne sera effectué dans ce cas.
  Il est précisé que, dans le cas des restaurants de type SCORP, une annulation de toute Commande effectuée sur le Site est possible sous réserve du respect
  d'un délai indiqué dans l'espace dédié du Site ou après accord avec le gérant du restaurant (en prenant contact avec ce dernier, dans le restaurant concerné).
</p>

<h2>7 - Retrait des Produits</h2>

<p>
  La réception des Produits sur le lieu de retrait ou de livraison ne peut se faire que le jour de retrait qui a été indiqué sur le Site, à partir de l'heure
  indiquée au Client sur le Site et avant la fermeture du créneau de retrait. En l'absence de créneau de retrait, la récupération de la Commande doit avoir lieu
  après l'ouverture du restaurant ou du lieu de retrait et à partir de l'heure indiquée dans son détail de commande ; la récupération de commande doit
  s'effectuer avant la fermeture du lieu de retrait.
</p>

<p>
  Il appartient donc au Client de vérifier les heures de fermeture du site, du lieu de commande ou du lieu de livraison, selon les restaurants, dans les cas
  explicités ci-dessus.
</p>

<p>Dans le cas des restaurants de type SCORP, le Client doit veiller à être présent sur le lieu de travail convenu au moment de la livraison.</p>

<p>
  Le Client devra retirer ses Produits sur le lieu de retrait ou de livraison de la commande validée lors de la Commande en se munissant du numéro de Commande
  reçu via le Site.
</p>

<p>
  En cas de non retrait d'une Commande par le Client le jour et l'heure/créneau prévus de retrait de sa Commande, les Produits seront retirés du lieu de
  retrait/livraison/restaurant par le Vendeur et le numéro de sa commande fourni via l'application deviendra invalide. La Commande non retirée ou non
  réceptionnée ne sera ni annulable, ni remboursable.
</p>

<h2>8- Consigne</h2>

<p>
  Dans le cas où la Commande fait l'objet d'un service de produits consignés, le prix de la consigne est compris dans le total à payer. Le produit consigné ne
  fait pas l'objet de TVA. La remise de la consigne s'effectue selon les modalités prévues à cet effet dans le restaurant. Le remboursement n'est pris en compte
  que lorsque le Client a effectivement remis son produit consigné. Dans le cas contraire, le produit consigné fait l'objet d'un achat définitif de produit
  comme un produit à part entière qui est facturé avec TVA, selon l'échéance précisée dans l'application en descriptif de la consigne ou sur le lieu où les
  collecteurs de consignes sont situés.
</p>

<h2>9- Réclamations</h2>

<p>
  Toute question ou réclamation concernant les Produits retirés sur le lieu de retrait/restaurant Click & Collect ou point de livraison du site validé lors de
  la commande, devra être faite dans un délai maximum de quarante-huit (48) heures après le retrait desdits Produits, auprès du Vendeur, par courrier, à
  l'adresse du restaurant principal du site ou directement par mail au responsable du restaurant principal lors de toute Commande. Passé ce délai, aucune
  question ni aucune réclamation ne pourront être prises en compte.
</p>

<p>Le Client accepte expressément que le récapitulatif de Commande lui soit transmis par email ou via le Site selon les options qui lui sont offertes.</p>

<p>
  Toute question ou réclamation sur le fonctionnement technique du Site devra être faite par courriel à l'adresse suivante :
  <a href="mailto:support-portail@elior.com">support-portail&#64;elior.com</a>
</p>

<h2>10 - Prix</h2>

<p>
  Les prix figurants sur les pages de Commande en ligne du Site sont des prix TTC (toutes taxes comprises) en euro tenant compte de la TVA applicable au jour de
  la Commande.
</p>

<p>
  Le Vendeur se réserve le droit de modifier ses prix à tout moment, étant toutefois entendu que le prix figurant au catalogue le jour de la Commande sera le
  seul applicable.
</p>

<h2>11 - Modalités en cas de paiement de la Commande en ligne</h2>

<p>
  Les Commandes effectuées sur le Site sont payables en utilisant les moyens de paiement proposés par le Site ou, pour le cas des restaurants de type SCORP,
  selon les modalités définies contractuellement avec l'employeur du Client.
</p>

<p>Les paiements sont réalisés par le biais d'un système fiable et sécurisé de paiement.</p>

<p>
  Le Vendeur garantit la préservation, par ses partenaires, du caractère confidentiel des numéros de carte bancaire par des procédures de protection et de
  cryptologie.
</p>

<p>
  Toutes les transactions bancaires s'effectuent sur le Site de manière sécurisée via le protocole SSL (Secure Sockets Layer) qui crypte l'information afin de
  protéger toutes les données liées aux informations personnelles et aux moyens de paiement.
</p>

<p>
  Les informations sur le numéro de carte bancaire, cryptogramme visuel et date de validité communiquées par le Client lors de la passation de la Commande ne
  seront pas stockées sur les serveurs du Vendeur dans la mesure où la transaction s'opère directement sur le site du partenaire en charge des transactions
  bancaires.
</p>

<h2>12 - Responsabilité</h2>

<p>
  Le Vendeur n'est tenu que d'une obligation de moyens en ce qui concerne le fonctionnement et la continuité du Site. Le Vendeur ne pourra en aucun cas être
  tenu responsable :
</p>

<ul>
  <li>
    des vitesses d'accès au Site depuis d'autres sites Internet, des vitesses d'ouverture et de consultation des pages du Site, de ralentissements externes, de
    la suspension ou de l'inaccessibilité du service, de l'utilisation frauduleuse par des tiers de toutes les informations mises à disposition sur le Site ;
  </li>
  <li>
    pour des faits dus à un cas de force majeure tel que défini à l'article 16, des pannes et des problèmes d'ordre technique concernant le matériel, des
    programmes, des logiciels de réseau Internet pouvant, le cas échéant, entraîner la suspension ou la cessation du service ;
  </li>
  <li>
    si le service proposé par le Site s'avère incompatible ou présente des dysfonctionnements avec certains logiciels, configurations, systèmes d'exploitation
    ou équipements du Client.
  </li>
</ul>

<p>
  Le Vendeur ne peut être tenu pour responsable des dommages de toute nature tant matériels qu'immatériels qui pourraient résulter d'une mauvaise utilisation de
  l'identifiant ou du mode opératoire de passation de Commande. La responsabilité du Vendeur ne pourra être engagée pour un risque inhérent à l'utilisation du
  réseau Internet tel que perte de données, intrusion, virus, rupture du service ou tout autre risque assimilé.
</p>

<p>
  Une fois le Produit retiré ou reçu, il appartient au Client de prendre les mesures nécessaires pour s'assurer la bonne conservation du Produit et de prendre
  les mesures qui s'imposent si le Produit semble non consommable (appeler les services, ne pas le consommer, etc.).
</p>

<h2>13 - Protection des données personnelles</h2>

<p>
  Les données personnelles recueillies sur le Site dans le cadre des formulaires d'inscription et de contact, services personnalisés ou tout autre questionnaire
  font l'objet d'un traitement automatisé par le Vendeur ou, le cas échéant, toute autre Société du groupe ELIOR qui sont responsables du traitement ou
  co-responsables de traitement, selon le cas.
</p>

<p>
  Les données personnelles sont collectées en vue de permettre au Client de créer et de gérer un compte sur le Site (notamment : permettre d'alimenter la carte
  de cantine par paiement en ligne, de passer en caisse avec accès ticket dématérialisé), faire bénéficier de services en ligne (notamment : consultation de
  l'affluence d'un restaurant et du menu), faire bénéficier de service de commande en ligne, répondre aux demandes, contacter le Client et/ou l'informer sur
  l'exécution d'un service, sur son suivi de consommation, sur le solde de son compte convive, sur les services que propose le Vendeur, sur du contenu
  personnalisé et sur toutes informations utiles.
</p>

<p>
  Les données colletées sont principalement les suivantes : nom, prénom, adresse email, numéro de téléphone, site de rattachement du Client, le cas échéant
  moment de livraison souhaité (matin, midi ou soir), intitulé du point de livraison, numéro de badge ou numéro de matricule, nombre de Produits commandés,
  montant des Commandes, types de Commandes, détail des Produits commandés, solde du badge, code site caisse, code TVA applicable, subvention.
</p>

<p>
  Le Client peut décider de ne pas communiquer ses données personnelles, cependant, certaines informations demandées dans les formulaires en ligne sont
  obligatoires. En cas d'absence de saisie ou de saisie erronée, les informations ne sont pas envoyées au responsable du traitement et le Client ne pourra pas
  bénéficier des services du Site. Le Client en est formé dans le cadre du processus de Commande.
</p>

<p>
  Les données permettant l'identification du Client peuvent être collectées directement auprès du Client au moment de son inscription, mais peuvent également
  être collectées auprès de l'employeur du Client via le système de caisse du restaurant qui reçoit les données transmises par ce dernier.
</p>

<p>
  Les données de suivi de consommation sont obtenues par interrogation des données collectées par les systèmes de caisse du restaurant lors du passage en caisse
  ou de la Commande.
</p>

<p>
  Les données personnelles collectées via le Site sont utilisées exclusivement pour la réalisation des services du Site. A ce titre, les destinataires de ces
  données sont les services du responsable du traitement et ses sous-traitants ainsi que tout autre service d'une société membre du Groupe ELIOR intervenant
  dans la réalisation du traitement.
</p>

<p>
  La base légale des traitements de données personnelles permettant au Client d'accéder à son compte sur le Site et de le gérer est le consentement du Client
  (article 6. 1. a du RGPD). Le Client peut gérer et modifier ses préférences à tout moment en se rendant dans l'onglet « Mon Compte ».
</p>

<p>
  La base légale des traitements de données personnelles pour communiquer avec le Client en général est l'intérêt légitime du responsable de traitement dans le
  cadre des finalités suivantes : permettre de préparer la Commande et réaliser la mise à disposition des Produits ou la livraison de ces derniers, tenir les
  dossiers à jour et étudier comment le Client utilise les services de son compte, gérer efficacement ses demandes, maintenir le Site à jour et pertinent.
</p>

<p>
  Les données personnelles sont stockées par le responsable du traitement et/ou ses sous-traitants et sont conservées de manière sécurisée pour la durée
  nécessaire à la réalisation des finalités énoncées ci-dessus pour lesquelles elles sont collectées, en conformité avec la réglementation en vigueur et jusqu'à
  la fermeture du compte du Client.
</p>

<p>
  Conformément à la réglementation en vigueur et notamment le Règlement (UE) 2016/679 du 27 avril 2016, le Client bénéficie d'un droit d'accès à ses données
  personnelles, d'un droit de rectification et d'effacement de ces données, d'un droit de limitation du traitement de ces données, d'un droit à la portabilité
  de ces données et d'un droit d'opposition à leur traitement. Le Client peut exercer à tout moment ces droits auprès du Délégué à la protection des données en
  adressant un courrier à « ELIOR - DPO - Direction Juridique (39ème) - Tour Egée 11 allée de l'Arche - 92032 Paris La Défense Cedex » ou par email à
  <a href="mailto:gdpr-contact@eliorgroup.com">gdpr-contact&#64;eliorgroup.com</a>
</p>

<p>Le Client dispose de la possibilité de vérifier, compléter et supprimer les informations fournies en accédant à la section « Mon Compte ».</p>

<p>Données de géolocalisation :</p>

<p>
  Lorsque le Client utilise le Site et s'il a consenti à des services de localisation, le responsable du traitement peut recevoir des informations concernant sa
  localisation.
</p>

<p>
  Le responsable du traitement utilise ces informations exclusivement pour fournir des services nécessitant une localisation, tels que proposer des sites Elior
  géolocalisés à proximité de l'endroit où le Client se trouve.
</p>

<p>Ces données de localisation ne sont pas conservées par le responsable du traitement au-delà du temps de connexion de l'Utilisateur.</p>

<p>Notification par SMS/Email/Push :</p>

<p>
  Lorsque le Client utilise le Site, et, sous réserve qu'il ait consenti préalablement à des notifications SMS et/ou Email et/ou Push telle que cette faculté
  existe sur le Site (opt in / opt out) le responsable du traitement peut envoyer des informations concernant le solde du compte, la confirmation de paiement en
  ligne, du contenu personnalisé et toutes informations utiles concernant le compte et sur les services et offres en cours.
</p>

<p>
  Les données personnelles ne sont utilisées pour l'envoi d'éventuels messages de partenaires commerciaux que sous réserve du consentement préalable du Client.
</p>

<p>L'envoi de notification par SMS ou par Email ou Push peut être activé ou désactivé à tout moment en se rendant dans l'onglet « Mon Compte ».</p>

<h2>14 - Cookies</h2>

<p>
  Le Vendeur collecte automatiquement des informations relatives au Client grâce à des cookies permettant de suivre la navigation du Client au sein du Site. Les
  cookies sont des identifiants alphanumériques transférés sur le disque dur de l'ordinateur du Client via son navigateur Internet et qui permettent au Vendeur
  de reconnaître ce navigateur et ainsi de proposer au Client des fonctions plus innovantes et plus attractives.
</p>

<p>
  Le Client peut toutefois configurer son ordinateur pour s'opposer à l'enregistrement de cookies. Pour en savoir plus sur les Cookies, cliquez sur l'onglet «
  configuration optimale » qui se trouve […].
</p>

<p>Nous utilisons deux sortes de cookies sur le Site :</p>

<ul>
  <li>
    Les cookies de session, qui permettent à l'internaute de naviguer de manière optimale sur un Site sûr, convivial et efficace et qui ne servent qu'au bon
    fonctionnement du Site ; ces cookies incluent des cookies media et vidéos (par exemple YouTube) rendant la navigation sur le Site plus dynamique ; ces
    cookies sont temporaires et sont automatiquement effacés lorsque l'internaute quitte le Site ; ces cookies ne recueillent pas d'informations à partir de
    l'ordinateur de l'internaute ou de l'activité de celui-ci pendant qu'il se trouve sur le Site ;
  </li>
  <li>
    Les cookies permanents, qui permettent d'étudier le comportement des internautes sur une certaine durée et de réaliser des analyses statistiques ; les
    analyses statistiques réalisées par les sociétés du Groupe grâce aux données contenues dans les cookies sont effectuées de manière globale et non pas
    individu par individu (statistiques de visites anonymes) ; les analyses sont réalisées via Google Analytics et portent sur les données suivantes : âge,
    sexe, centre d'intérêts ; les cookies permanents ne permettent pas aux Destinataires des données collectées de remonter par ce biais aux personnes physiques
    ;
  </li>
</ul>

<p>
  Actuellement, nous ne mettons pas en place sur le Site de cookies tiers, c'est-à-dire de cookies mettant en œuvre des publicités ou des bannières pour des
  produits tiers ou des services présents sur le Site.
</p>

<h2>15 - Indivisibilité</h2>

<p>
  La nullité d'une des clauses des présentes CGV en application notamment d'une loi, d'un règlement ou à la suite d'une décision de justice n'entrainera pas la
  nullité des présentes CGV.
</p>

<h2>16 - Propriété intellectuelle</h2>

<p>
  Toute détérioration, ainsi que, en l'absence d'autorisation, toute reproduction, téléchargement, copie, modification, utilisation commerciale, totale ou
  partielle, des différents éléments du Site (notamment les contenus éditoriaux et les photos) sont interdits et expose son ou ses auteurs à des poursuites. Les
  Conditions Générales de Vente n'autorisent en aucun cas la reproduction, la modification ou l'utilisation commerciale des différents éléments du Site.
</p>

<h2>17- Force majeure</h2>

<p>
  Sont réputés événements de force majeure ceux qui imprévisibles, irrésistibles et extérieurs rendent impossible de façon absolue, l'exécution du contrat de
  vente dans les conditions prévues.
</p>

<p>
  Tous les événements de force majeure, définis par la réglementation et la jurisprudence constituent, une cause de suspension ou d'extinction des obligations
  du restaurant. Le restaurant et, plus généralement, les sociétés du Groupe ELIOR, ne sauraient être tenus pour responsable de l'inexécution du contrat conclu
  en cas de survenance de l'un des événements susmentionnés.
</p>

<h2>18 - Règlement des litiges</h2>

<p>
  Les présentes CGV sont soumises à la loi française. En cas de litige, le Client s'adressera en priorité au Vendeur afin de trouver une solution amiable. A
  défaut, la compétence est attribuée aux tribunaux compétents à en connaitre.
</p>
